module.exports = __webpack_public_path__ + "img/26-uHaven.6435a222.jpg";